import { render, staticRenderFns } from "./MessagesBlock.vue?vue&type=template&id=167100a2&scoped=true"
import script from "./MessagesBlock.vue?vue&type=script&lang=js"
export * from "./MessagesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167100a2",
  null
  
)

export default component.exports